"use client"
import type { FragmentOf, Timeframe } from "@opensea/graphql"
import { graphql, readFragment } from "@opensea/graphql"
import { ChangeAnimation, NumberDisplay } from "@opensea/ui-kit"

export const StatsTableRowSalesFragment = graphql(`
  fragment StatsTableRowSales on Collection {
    stats {
      sales
      oneMinute {
        sales
      }
      fiveMinute {
        sales
      }
      fifteenMinute {
        sales
      }
      oneDay {
        sales
      }
      oneHour {
        sales
      }
      sevenDays {
        sales
      }
      thirtyDays {
        sales
      }
    }
  }
`)

type Props = {
  className?: string
  collection: FragmentOf<typeof StatsTableRowSalesFragment>
  timeframe: Timeframe
}

export function StatsTableRowSales({
  timeframe,
  collection: collectionKey,
}: Props) {
  const collection = readFragment(StatsTableRowSalesFragment, collectionKey)

  function getSales() {
    switch (timeframe) {
      case "ONE_MINUTE":
        return collection.stats.oneMinute.sales
      case "FIVE_MINUTE":
        return collection.stats.fiveMinute.sales
      case "FIFTEEN_MINUTE":
        return collection.stats.fifteenMinute.sales
      case "ALL_TIME":
        return collection.stats.sales
      case "ONE_DAY":
        return collection.stats.oneDay.sales
      case "ONE_HOUR":
        return collection.stats.oneHour.sales
      case "SEVEN_DAYS":
        return collection.stats.sevenDays.sales
      case "THIRTY_DAYS":
        return collection.stats.thirtyDays.sales
      default:
        return collection.stats.sales
    }
  }
  const sales = getSales()

  return (
    <ChangeAnimation display="full" value={sales}>
      <NumberDisplay display="full" value={sales} />
    </ChangeAnimation>
  )
}
